import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import Modal from 'components/Modal/Modal.react';
import styles from 'components/Modal/Modal.scss';
import React from 'react';
import TextInput from 'components/TextInput/TextInput.react';

export default class DeleteRowsDialog extends React.Component {
  constructor() {
    super();

    this.state = {
      confirmation: '',
    };

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  onCloseClick() {
    this.props.onCancel();
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  valid() {
    if (this.state.confirmation === this.props.className) {
      return true;
    }
    if (!this.props.selection['*'] && Object.keys(this.props.selection).length < 10) {
      return true;
    }
    return false;
  }

  render() {
    let content = null;
    const selectionLength = Object.keys(this.props.selection).length;

    const deleteText = this.props.relation ? 'Detach' : 'Delete';
    const deleteText2 = this.props.relation ? 'Detached' : 'Deleted';

    if (selectionLength === 1 && !this.props.selection['*']) {
      content = (
        <p className={styles.only}>Row with objectId <strong>{Object.keys(this.props.selection)[0]}</strong> will be {deleteText}!</p>
      );
    } else {
      // Object.keys(this.props.selection)
      content = (
        <p className={styles.only}>This action cannot be undone!</p>
      );
    }

    if (this.props.selection['*'] || selectionLength >= 10) {
      content = (
        <Field
          label={
            <Label
              text="Confirm this action"
              description="Enter the current class name to continue." />
          }
          input={
            <TextInput
              placeholder="Current class name"
              value={this.state.confirmation}
              onChange={confirmation => this.setState({ confirmation })} />
          } />
      );
    }

    return (
      <Modal
        type={Modal.Types.DANGER}
        icon="warn-outline"
        title={this.props.selection['*'] ? `${deleteText} all rows?` : (selectionLength === 1 ? `${deleteText} this row?` : `${deleteText} ${selectionLength} rows?`)}
        subtitle={this.props.relation ? 'You need to delete origin record. This is a reference.' : 'Be careful, this action cannot be undone!'}
        disabled={!this.valid()}
        confirmText={`Yes, ${this.props.relation ? 'detach' : 'delete'}`}
        cancelText="Cancel"
        onCancel={this.onCloseClick.bind(this)}
        onConfirm={this.props.onConfirm}>
        {content}
      </Modal>
    );
  }
}
